<div class="loading">
  <!--<img src="./assets/images/building_loader.gif"> -->
</div>
